export default "__VITE_ASSET__8cc7f8d2__"